function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "g1004"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "g1006"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "g1008"
});

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "g1010"
});

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  id: "g1012"
});

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  id: "g1014"
});

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  id: "g1016"
});

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  id: "g1018"
});

var _ref10 =
/*#__PURE__*/
React.createElement("g", {
  id: "g1020"
});

var _ref11 =
/*#__PURE__*/
React.createElement("g", {
  id: "g1022"
});

var _ref12 =
/*#__PURE__*/
React.createElement("g", {
  id: "g1024"
});

var _ref13 =
/*#__PURE__*/
React.createElement("g", {
  id: "g1026"
});

var _ref14 =
/*#__PURE__*/
React.createElement("g", {
  id: "g1028"
});

var _ref15 =
/*#__PURE__*/
React.createElement("g", {
  id: "g1030"
});

var _ref16 =
/*#__PURE__*/
React.createElement("g", {
  id: "g1032"
});

var SvgGenerate = function SvgGenerate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25.625 25.625",
    style: {
      enableBackground: "new 0 0 25.625 25.625"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("title", null, title), React.createElement("g", {
    id: "g1002"
  }, React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M22.079,17.835c-1.548-1.324-3.119-2.126-4.648-0.804l-0.913,0.799   c-0.668,0.58-1.91,3.29-6.712-2.234C5.005,10.079,7.862,9.22,8.531,8.645l0.918-0.8c1.521-1.325,0.947-2.993-0.15-4.71l-0.662-1.04   C7.535,0.382,6.335-0.743,4.81,0.58L3.986,1.3C3.312,1.791,1.428,3.387,0.971,6.419c-0.55,3.638,1.185,7.804,5.16,12.375   c3.97,4.573,7.857,6.87,11.539,6.83c3.06-0.033,4.908-1.675,5.486-2.272l0.827-0.721c1.521-1.322,0.576-2.668-0.973-3.995   L22.079,17.835z",
    id: "path1000"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.0267097
    },
    d: "m 24.470453,4.6562717 h -3.85689 c -0.125293,0 -0.226877,-0.09011 -0.226877,-0.201246 v -3.4212 c 0,-0.55568999 -0.507923,-1.00623499 -1.134378,-1.00623499 -0.626458,0 -1.134381,0.450545 -1.134381,1.00623499 v 3.4212 c 0,0.111138 -0.101584,0.201246 -0.226875,0.201246 h -3.856891 c -0.626458,0 -1.134381,0.450545 -1.134381,1.006234 0,0.55569 0.507923,1.006237 1.134381,1.006237 h 3.856891 c 0.125291,0 0.226875,0.09011 0.226875,0.201246 v 3.4211993 c 0,0.55569 0.507923,1.006235 1.134381,1.006235 0.626455,0 1.134378,-0.450545 1.134378,-1.006235 V 6.8699887 c 0,-0.111138 0.101584,-0.201246 0.226877,-0.201246 h 3.85689 c 0.626457,0 1.13438,-0.450547 1.13438,-1.006237 0,-0.555689 -0.507923,-1.006234 -1.13438,-1.006234 z m 0,0",
    id: "path4768"
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGenerate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/generate.03d0abc5.svg";
export { ForwardRef as ReactComponent };